export const SET_SERVICE_TYPES = "SET_SERVICE_TYPES";
